// const mapStyle = [
//   {
//       "featureType": "water",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#e9e9e9"
//           },
//           {
//               "lightness": 17
//           }
//       ]
//   },
//   {
//       "featureType": "landscape",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#f5f5f5"
//           },
//           {
//               "lightness": 20
//           }
//       ]
//   },
//   {
//       "featureType": "road.highway",
//       "elementType": "geometry.fill",
//       "stylers": [
//           {
//               "color": "#ffffff"
//           },
//           {
//               "lightness": 17
//           }
//       ]
//   },
//   {
//       "featureType": "road.highway",
//       "elementType": "geometry.stroke",
//       "stylers": [
//           {
//               "color": "#ffffff"
//           },
//           {
//               "lightness": 29
//           },
//           {
//               "weight": 0.2
//           }
//       ]
//   },
//   {
//       "featureType": "road.arterial",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#ffffff"
//           },
//           {
//               "lightness": 18
//           }
//       ]
//   },
//   {
//       "featureType": "road.local",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#ffffff"
//           },
//           {
//               "lightness": 16
//           }
//       ]
//   },
//   {
//       "featureType": "poi",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#f5f5f5"
//           },
//           {
//               "lightness": 21
//           }
//       ]
//   },
//   {
//       "featureType": "poi.park",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#dedede"
//           },
//           {
//               "lightness": 21
//           }
//       ]
//   },
//   {
//       "elementType": "labels.text.stroke",
//       "stylers": [
//           {
//               "visibility": "on"
//           },
//           {
//               "color": "#ffffff"
//           },
//           {
//               "lightness": 16
//           }
//       ]
//   },
//   {
//       "elementType": "labels.text.fill",
//       "stylers": [
//           {
//               "saturation": 36
//           },
//           {
//               "color": "#333333"
//           },
//           {
//               "lightness": 40
//           }
//       ]
//   },
//   {
//       "elementType": "labels.icon",
//       "stylers": [
//           {
//               "visibility": "off"
//           }
//       ]
//   },
//   {
//       "featureType": "transit",
//       "elementType": "geometry",
//       "stylers": [
//           {
//               "color": "#f2f2f2"
//           },
//           {
//               "lightness": 19
//           }
//       ]
//   },
//   {
//       "featureType": "administrative",
//       "elementType": "geometry.fill",
//       "stylers": [
//           {
//               "color": "#fefefe"
//           },
//           {
//               "lightness": 20
//           }
//       ]
//   },
//   {
//       "featureType": "administrative",
//       "elementType": "geometry.stroke",
//       "stylers": [
//           {
//               "color": "#fefefe"
//           },
//           {
//               "lightness": 17
//           },
//           {
//               "weight": 1.2
//           }
//       ]
//   }
// ];

const mapStyle = [
	{
		featureType: 'all',
		elementType: 'labels.text.fill',
		stylers: [
			{
				saturation: 36,
			},
			{
				color: '#333333',
			},
			{
				lightness: 40,
			},
		],
	},
	{
		featureType: 'all',
		elementType: 'labels.text.stroke',
		stylers: [
			{
				visibility: 'off',
			},
			{
				lightness: 16,
			},
		],
	},
	{
		featureType: 'all',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'administrative',
		elementType: 'geometry.fill',
		stylers: [
			{
				lightness: 20,
			},
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'administrative',
		elementType: 'geometry.stroke',
		stylers: [
			{
				lightness: 17,
			},
			{
				weight: '0.8',
			},
			{
				visibility: 'on',
			},
			{
				color: '#999999',
			},
		],
	},
	{
		featureType: 'landscape',
		elementType: 'geometry',
		stylers: [
			{
				color: '#f5f5f5',
			},
			{
				lightness: 20,
			},
		],
	},
	{
		featureType: 'poi',
		elementType: 'geometry',
		stylers: [
			{
				color: '#f5f5f5',
			},
			{
				lightness: 21,
			},
		],
	},
	{
		featureType: 'poi.park',
		elementType: 'geometry',
		stylers: [
			{
				color: '#dedede',
			},
			{
				lightness: 21,
			},
		],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#dddddd',
			},
			{
				lightness: 17,
			},
		],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry.stroke',
		stylers: [
			{
				lightness: 29,
			},
			{
				weight: 0.2,
			},
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'road.arterial',
		elementType: 'geometry',
		stylers: [
			{
				lightness: 18,
			},
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'road.local',
		elementType: 'geometry',
		stylers: [
			{
				lightness: 16,
			},
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'transit',
		elementType: 'geometry',
		stylers: [
			{
				color: '#f2f2f2',
			},
			{
				lightness: 19,
			},
		],
	},
	{
		featureType: 'water',
		elementType: 'geometry',
		stylers: [
			{
				color: '#dddddd',
			},
			{
				lightness: 17,
			},
		],
	},
];

class DealerMapWorker {
	map: any = undefined;
	autocomplete: any = undefined;
	originLocation: any = undefined;
	DOM = {} as Record<string, any>;
	filters = {
		service: undefined,
		company: undefined,
	};

	constructor() {}

	cache() {
		this.DOM = {
			mapEl: document.getElementById('map'),
			serviceFilter: document.querySelector('#ffMapFilter'),
			companySearch: document.querySelector('#ffMapCompanySearch'),
			panelClose: document.querySelector('.ffjs-mapSidebarClose'),
			searchInput: document.querySelector('#ffMapLocationSearch'),
			message: document.querySelector('.ffjs-searchMessage'),
			sidebar: document.querySelector('.ffjs-mapSidebar'),
			sidebarContent: document.querySelector('.ffjs-mapSidebarContent'),
		};
	}

	init() {
		this.cache();
		if (typeof google === 'undefined' || !google.maps || !this.DOM.mapEl) {
			return;
		}
		this.initMap();
		this.events();
	}

	initMap() {
		// Create the map.
		this.map = new google.maps.Map(this.DOM.mapEl, {
			zoom: 3,
			center: { lat: 10, lng: 0 }, // {lat: 47.7417676, lng: -122.1569857},
			styles: mapStyle,
			disableDefaultUI: true,
		});

		// Load the stores GeoJSON onto the map.
		// map.data.loadGeoJson('stores.json', {idPropertyName: 'storeid'});
		this.map.data.addGeoJson(mapData, { idPropertyName: 'storeid' });

		// Define the custom marker icons, using the store's "category".
		this.map.data.setStyle((feature) => {
			return {
				visible: feature.getProperty('active'),
				icon: {
					url: `${templateDirectoryUri}/dist/images/dealerMap/pin.png`,
					scaledSize: new google.maps.Size(20, 26),
				},
			};
		});

		// Show the information for a store when its marker is clicked.
		this.map.data.addListener('click', (event) => {
			this.showStoresList([{ storeid: event.feature.getProperty('storeid') }]);
			const position = event.feature.getGeometry().get();
			this.map.setCenter(position);
			this.map.setZoom(5);
			this.scrollToElement(this.DOM.searchInput);
		});

		// Make the search bar into a Places Autocomplete search bar and select
		// which detail fields should be returned about the place that
		// the user selects from the suggestions.
		this.autocomplete = new google.maps.places.Autocomplete(this.DOM.searchInput);
		this.autocomplete.setFields(['address_components', 'geometry', 'name']);

		// Set the origin point when the user selects an address
		// const originMarker = new google.maps.Marker({map: map});
		// originMarker.setVisible(false);
		this.originLocation = this.map.getCenter();
	}

	events() {
		this.DOM.serviceFilter.addEventListener('change', this.serviceFilterChange.bind(this));
		this.DOM.companySearch.addEventListener('input', this.companySearchChange.bind(this));
		this.DOM.panelClose.addEventListener('click', (e) =>
			e.currentTarget.parentNode.classList.remove('open')
		);
		this.autocomplete.addListener('place_changed', this.placeChanged.bind(this));
	}

	async placeChanged() {
		// originMarker.setVisible(false);
		this.originLocation = this.map.getCenter();
		const place = this.autocomplete.getPlace();
		if (!place.geometry) {
			// User entered the name of a Place that was not suggested and
			// pressed the Enter key, or the Place Details request failed.
			//  window.alert('No address available for input: \'' + place.name + '\'');
			this.DOM.searchInput.classList.add('js-error');
			this.DOM.message.classList.add('js-active');
			return;
		}
		this.DOM.searchInput.classList.remove('js-error');
		this.DOM.message.classList.remove('js-active');
		this.scrollToElement(this.DOM.searchInput);
		// Recenter the map to the selected address
		this.originLocation = place.geometry.location;
		this.map.setCenter(this.originLocation);
		this.map.setZoom(5);

		// originMarker.setPosition(originLocation);
		// originMarker.setVisible(true);

		const countryComponent = place.address_components.find(
			(el) => el.types.indexOf('country') > -1
		);
		const countryCode = countryComponent?.short_name;
		if (!countryCode) return;

		// Use the selected address as the origin to calculate distances
		// to each of the store locations
		const rankedStores = await calculateDistances(this.map.data, this.originLocation, countryCode);
		this.showStoresList(rankedStores);

		return;
	}

	serviceFilterChange(e) {
		this.filters.service = e.currentTarget.value;
		this.filterChange(e);
	}

	companySearchChange(e) {
		this.filters.company = (e.currentTarget.value || '').toLowerCase();
		this.filterChange(e);
	}

	filterChange(e) {
		var self = this;
		if (!this.filters.service && !this.filters.company) {
			this.DOM.sidebar.classList.remove('open');
			this.map.data.forEach(function (feature) {
				feature.setProperty('active', true);
			});
			return;
		}

		const allIds = [];
		const satisfyIds = []; //string[]
		this.map.data.forEach(function (feature) {
			allIds.push({ storeid: feature.getProperty('storeid') });
			const satisfiesFilters = self.checkLocation(feature);
			feature.setProperty('active', satisfiesFilters);
			if (satisfiesFilters) satisfyIds.push(feature.getProperty('storeid'));
		});
		this.showStoresList(allIds);
		this.scrollToElement(e.currentTarget);
		if (satisfyIds.length === 1) {
			const currentStore = this.map.data.getFeatureById(satisfyIds[0]);
			const position = currentStore.getGeometry().get();
			this.map.setCenter(position);
			this.map.setZoom(5);
		}
	}

	checkLocation(feature) {
		const services = feature.getProperty('services') || [];
		const satisfiesService = !this.filters.service || services.indexOf(this.filters.service) > -1;
		const companyName = feature.getProperty('name') || '';
		const companyIndex = companyName.toLowerCase();
		const satisfiesCompany =
			!this.filters.company || companyIndex.indexOf(this.filters.company) > -1;
		return satisfiesService && satisfiesCompany;
	}

	scrollToElement(el) {
		const top = el.getBoundingClientRect().top + window.scrollY - 68;
		window.scroll({
			top,
			behavior: 'smooth',
		});
	}

	showStoresList(stores) {
		const activeStores = stores.filter((store) => {
			const currentStore = this.map.data.getFeatureById(store.storeid);
			if (!currentStore) return false;
			return !!currentStore.getProperty('active');
		});

		if (activeStores.length == 0) {
			this.DOM.sidebarContent.innerHTML = `<div class="directoryEntry"><h3>No dealers match your search. Update your filters and try again.</h3></div>`;
			this.DOM.sidebar.classList.add('open');
			return;
		}

		// Clear the previous details
		while (this.DOM.sidebarContent.lastChild) {
			this.DOM.sidebarContent.removeChild(this.DOM.sidebarContent.lastChild);
		}

		stores.forEach((store) => {
			const currentStore = this.map.data.getFeatureById(store.storeid);
			if (!currentStore) return;
			const active = currentStore.getProperty('active');
			if (!active) return;
			// Add store details with text formatting
			const wrapper = document.createElement('div');
			wrapper.addEventListener('click', () => {
				const position = currentStore.getGeometry().get();
				this.map.setCenter(position);
				this.map.setZoom(9);
			});
			wrapper.classList.add('directoryEntry');
			const services = currentStore.getProperty('serviceLabels');
			const demoOptions = currentStore.getProperty('demoOptions');
			const html = `
        <p class="name"><strong>${currentStore.getProperty('name')}</strong></p>
        <p class="address">${currentStore.getProperty('address').replace(/(?:\r\n|\r|\n)/g, '<br>')}</p>
        <div class="metas">
          ${currentStore.getProperty('hours') ? `<p class="meta"><strong>Hours:</strong> ${currentStore.getProperty('hours')}</p>` : ''}
          <p class="meta"><strong>Phone:</strong> ${currentStore.getProperty('phone')}</p>
          <p class="meta"><strong>Web:</strong> <a href="${currentStore.getProperty('url')}" target="_blank" rel="noopener noreferrer">${currentStore.getProperty('url')}</a></p>
          <p class="meta"><strong>Email:</strong> <a href="mailto:${currentStore.getProperty('email')}">${currentStore.getProperty('email')}</a></p>
        </div>
        ${
					services.length
						? `<div class="services">
            <p><strong>Services</strong></p>
            <ul>
              ${services.map((service) => `<li>${service}</li>`).join('')}
            </ul>
          </div>`
						: ''
				}
        ${
					demoOptions.length
						? `<div class="services">
            <p><strong>Demo Options</strong></p>
            <ul>
              ${demoOptions.map((demo) => `<li>${demo}</li>`).join('')}
            </ul>
          </div>`
						: ''
				}
        ${
					currentStore.getProperty('description')
						? `<div class="about">
            <p><strong>About</strong></p>
            <p>${currentStore.getProperty('description')}</p>
          </div>`
						: ''
				}
      `;
			wrapper.innerHTML = html;
			this.DOM.sidebarContent.appendChild(wrapper);
		});

		// Open the panel
		this.DOM.sidebar.classList.add('open');

		return;
	}
}

window.initMap = function () {
	const worker = new DealerMapWorker();
	worker.init();
};

if (window.__dealerMapInitPending) {
	window.initMap();
}

async function calculateDistances(data, origin, countryCode) {
	const stores = [];
	const destinations = [];

	// Build parallel arrays for the store IDs and destinations
	data.forEach((store) => {
		const storeCountryCode = store.getProperty('countryCode');
		if (storeCountryCode !== countryCode) return;
		const storeNum = store.getProperty('storeid');
		const storeLoc = store.getGeometry().get();

		stores.push(storeNum);
		destinations.push(storeLoc);
	});

	if (!destinations.length) return [];

	// Retrieve the distances of each store from the origin
	// The returned list will be in the same order as the destinations list
	const service = new google.maps.DistanceMatrixService();
	const getDistanceMatrix = (service, parameters) =>
		new Promise((resolve, reject) => {
			service.getDistanceMatrix(parameters, (response, status) => {
				if (status != google.maps.DistanceMatrixStatus.OK) {
					reject(response);
				} else {
					const distances = [];
					const results = response.rows[0].elements;
					for (let j = 0; j < results.length; j++) {
						const element = results[j];
						if (element.status === 'ZERO_RESULTS') continue;
						const distanceText = element.distance.text;
						const distanceVal = element.distance.value;
						const distanceObject = {
							storeid: stores[j],
							distanceText: distanceText,
							distanceVal: distanceVal,
						};
						distances.push(distanceObject);
					}

					resolve(distances);
				}
			});
		});

	let distancesList: { storeid: unknown; distanceText: string; distanceVal: number }[] = [];
	try {
		distancesList = (await getDistanceMatrix(service, {
			origins: [origin],
			destinations: destinations.slice(0, 25), //Max dimensions error over 25
			travelMode: 'DRIVING',
			unitSystem: google.maps.UnitSystem.METRIC,
		})) as typeof distancesList;
	} catch (error) {
		console.log(error);
	}

	distancesList.sort((first, second) => {
		return first.distanceVal - second.distanceVal;
	});

	return distancesList;
}
